import { addYears } from 'date-fns/addYears'
import { useTranslation } from 'react-i18next'
import { InputDay } from './InputDay'

type Props = {
  name?: string
  label?: string
  date?: Date
  minDate?: Date
  maxDate?: Date
  onChange?: (date: Date) => void
  loading?: boolean
  disabled?: boolean
  hideLockIcon?: boolean
}

export function InputStartDay(props: Props) {
  const { t } = useTranslation('purchase-form')

  const handleSelect = (date: Date) => {
    props.onChange?.(date)
  }

  // Ceiling comes from the backend (ProductOffer.maxStartDate) when available, based on underwriter guidelines:
  // https://github.com/HedvigInsurance/underwriter/blob/master/src/main/kotlin/com/hedvig/underwriter/model/Quote.kt#L83
  const dateToday = new Date()
  const fromDate = props.minDate ?? dateToday
  const toDate = props.maxDate ?? addYears(dateToday, 1)

  return (
    <InputDay
      name={props.name}
      label={props.label ?? t('START_DATE_FIELD_LABEL')}
      required={true}
      selected={props.date}
      fromDate={fromDate}
      toDate={toDate}
      onSelect={handleSelect}
      loading={props.loading}
      disabled={props.disabled}
      hideLockIcon={props.hideLockIcon}
    />
  )
}
